import type { FC } from 'react';
import React, { memo } from 'react';

import { Typography } from '@mui/material';

import { CommentIcon, PaperClipIcon } from '@setup/svg-icons/svg-icons';

import { AdditionalInfoContainer, AdditionalInfoItem } from './AdditionalInfo.style';

type AdditionalInfoProps = {
  document_count?: number;
  is_unread_documents?: boolean;
  photo_count?: number;
  is_unread_photos?: boolean;
  comment_count?: number;
  is_unread_comments?: boolean;
};
export const AdditionalInfo: FC<AdditionalInfoProps> = ({
  document_count,
  is_unread_documents,
  comment_count,
  is_unread_comments,
}) => {
  return (
    <AdditionalInfoContainer>
      <AdditionalInfoItem isUnread={is_unread_comments}>
        <CommentIcon />
        <Typography color={(theme) => theme.palette.case.neutral.n600} variant="t14m">
          {comment_count || 0}
        </Typography>
      </AdditionalInfoItem>

      <AdditionalInfoItem isUnread={is_unread_documents}>
        <PaperClipIcon />
        <Typography color={(theme) => theme.palette.case.neutral.n600} variant="t14m">
          {document_count || 0}
        </Typography>
      </AdditionalInfoItem>
    </AdditionalInfoContainer>
  );
};

export default memo(AdditionalInfo);
